import { IPublicTypeHotkeyCallbackConfig } from './';

export interface IPublicTypeHotkeyCallbacks {
  [key: string]: IPublicTypeHotkeyCallbackConfig[];
}